export default "__VITE_ASSET__DlhckPFX__"